export default "__VITE_ASSET__BUDv7GXr__"